import { render, staticRenderFns } from "./gridView.vue?vue&type=template&id=6042b574&scoped=true&"
import script from "./gridView.vue?vue&type=script&lang=js&"
export * from "./gridView.vue?vue&type=script&lang=js&"
import style0 from "./gridView.vue?vue&type=style&index=0&id=6042b574&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6042b574",
  null
  
)

export default component.exports